var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50.5 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,4.2c-0.7-0.3-1.3-0.7-2-1.1C42.9,1,38.9-0.1,34.9,0c-4-0.1-8,1-11.4,3.2c-2.2,1.5-4.9,2.2-7.5,2.2 c-2.7,0.1-5.3-0.7-7.5-2.1C7.5,2.7,6.7,2.2,5.7,1.8c-2-0.9-4.4,0-5.3,2c-0.9,2,0,4.4,2,5.3C3,9.4,3.7,9.8,4.4,10.1 c3.4,2.1,7.4,3.2,11.4,3.2c4,0.1,8-1,11.5-3.2c2.2-1.5,4.9-2.2,7.5-2.1c2.7-0.1,5.3,0.7,7.6,2.1c0.8,0.5,1.6,0.9,2.6,1.3 c2,0.8,4.4-0.2,5.2-2.2C51,7.4,50.2,5.2,48.3,4.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,18.1c-0.7-0.3-1.3-0.7-2-1.1c-3.4-2.1-7.4-3.2-11.5-3.2c-4-0.1-8,1-11.5,3.2c-2.2,1.5-4.9,2.2-7.5,2.2             c-2.7,0.1-5.3-0.7-7.5-2.2c-0.8-0.5-1.7-0.9-2.7-1.4c-2-0.9-4.4,0-5.3,2c-0.9,2,0,4.4,2,5.3C3,23.2,3.7,23.6,4.4,24             c3.4,2.1,7.4,3.2,11.4,3.2c4.1,0.1,8-1,11.5-3.2c2.2-1.5,4.9-2.2,7.5-2.1c2.7-0.1,5.3,0.7,7.6,2.1c0.8,0.4,1.6,0.9,2.6,1.3             c2,0.8,4.4-0.2,5.2-2.2C51,21.2,50.2,19,48.3,18.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.3,32c-0.7-0.3-1.3-0.7-2-1.1c-3.4-2.2-7.4-3.3-11.5-3.2c-4-0.1-8,1-11.4,3.2c-2.2,1.5-4.9,2.2-7.5,2.1             c-2.7,0.1-5.3-0.7-7.5-2.1c-0.8-0.5-1.7-0.9-2.7-1.4c-2-0.9-4.4,0-5.3,2c-0.9,2,0,4.4,2,5.3c0.7,0.3,1.4,0.7,2.1,1.1             c3.4,2.1,7.4,3.2,11.4,3.2c4,0.1,8-1,11.5-3.2c2.2-1.5,4.9-2.2,7.5-2.2c2.7-0.1,5.3,0.7,7.6,2.2c0.8,0.4,1.6,0.9,2.6,1.3             c2.1,0.8,4.4-0.2,5.2-2.3C50.9,35,50.1,32.9,48.3,32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVentIcon);
export default __webpack_public_path__ + "static/media/vent-icon.e426513172a6aa7b84421596d7762197.svg";
export { ForwardRef as ReactComponent };